import { NxPopoverComponent, NxPopoverMainContentDirective, NxPopoverTriggerDirective } from '@allianz/ng-aquila/popover';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AccessibilitySettingsService } from '../../services/accessibility-settings.service';

/** Header entry point for the accessibility settings (text size, dark mode), shown in a popover. */
@Component({
  selector: 'app-accessibility',
  imports: [NxPopoverComponent, NxPopoverTriggerDirective, NxPopoverMainContentDirective, TranslocoPipe],
  templateUrl: './accessibility.component.html',
  styleUrl: './accessibility.component.scss',
})
export class AccessibilityComponent {
  protected readonly settings = inject(AccessibilitySettingsService);
}
